<!-- eslint-disable vue/no-v-html -->
<template>
  <CoreDialog
    v-model="dialogOpened"
    v-bind="$attrs"
    :dialog-class="['q-pa-md', { 'confirm-dialog-new-design': newDesign }]"
  >
    <span
      class="bold q-mb-lg block text-center"
      :class="titleClass"
    >
      {{ title }}
    </span>
    <div>
      <slot><div v-html="message" /></slot>
    </div>
    <div class="bottom-bar">
      <QBtn
        v-if="!hideCancel"
        aria-label="Cancel"
        unelevated
        v-bind="cancelButtonProps"
        @click="cancel"
      >
        {{ cancelLabel }}
      </QBtn>
      <QBtn
        v-if="!hideConfirm"
        v-bind="confirmButtonProps"
        aria-label="Confirm"
        :color="confirmButtonProps.color || 'primary'"
        @click="confirm"
      >
        {{ confirmLabel }}
      </QBtn>
    </div>
  </CoreDialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    modelValue: {
      type: Boolean,
    },
    title: {
      type: String,
      required: true,
    },
    hideCancel: {
      type: Boolean,
    },
    hideConfirm: {
      type: Boolean,
    },
    confirmLabel: {
      type: String,
      default: "Confirm",
    },
    confirmButtonProps: {
      type: Object,
      default: () => ({}),
    },
    cancelLabel: {
      type: String,
      default: "Cancel",
    },
    titleClass: {
      type: String,
      default: "",
    },
    cancelButtonProps: {
      type: Object,
      default: () => ({}),
    },
    newDesign: {
      type: Boolean,
    },
    message: {
      type: String,
      default: null,
    },
  },
  emits: ["update:modelValue", "cancel", "confirm"],
  computed: {
    dialogOpened: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    },
    cancel() {
      this.close();
      this.$emit("cancel");
    },
    confirm() {
      this.close();
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss">
.streem-dialog.confirm-dialog-new-design {
  border-radius: 8px;

  .q-btn {
    border-radius: 4px;
  }
}

.instant-download {
  padding: 10px 0;

  .q-btn__content {
    line-height: 19px;
  }
}
</style>
